import React from "react";
import "./TextField.css";

const TextField = ({
  type = "text",
  disabled = false,
  label,
  value,
  defaultValue,
  placeholder,
  onChange,
  onKeyDown,
  required = false,
  tagline,
  taglineColor,
  autoComplete,
  className = "",
  bottomLabel,
  name,
  maxLength,
  onWheel,
  onBlur,
  labelStyle,
  inputStyle,
  mainContainerStyle,
  readOnly = false,
}) => {
  const isControlled = value !== undefined;
  const isReadOnly = readOnly || (isControlled && !onChange);

  const handleChange = (event) => {
    if (maxLength && event.target.value.length > maxLength) {
      return;
    }

    onChange?.(event);
  };

  return (
    <div
      className={[
        "katch-form-input",
        disabled && "katch-form-input--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={mainContainerStyle}
    >
      {label && (
        <label className="katch-form-input__label" style={labelStyle}>
          {label}

          {required && <span className="katch-form-input__required">*</span>}
        </label>
      )}

      {tagline && (
        <span
          className="katch-form-input__tagline"
          style={{ color: taglineColor }}
        >
          {tagline}
        </span>
      )}

      <input
        className="katch-form-input__field"
        type={type}
        name={name}
        value={isControlled ? (value ?? "") : undefined}
        defaultValue={!isControlled ? defaultValue : undefined}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onWheel={onWheel}
        disabled={disabled}
        readOnly={isReadOnly}
        required={required}
        autoComplete={autoComplete}
        style={inputStyle}
      />

      {bottomLabel && (
        <span className="katch-form-input__bottom-label">{bottomLabel}</span>
      )}
    </div>
  );
};

export default TextField;
